// extracted by mini-css-extract-plugin
module.exports = {"add_tag_container":"AddCaseTagPopup_add_tag_container__2Gfdl","autocomplete_container":"AddCaseTagPopup_autocomplete_container__1ryXM"};